import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Card from "../../components/Card/Card";
import CardBody from "../../components/Card/CardBody";
import CardHeader from "../../components/Card/CardHeader";
import Muted from "../../components/Typography/Muted";
import Button from "../../components/CustomButtons/Button.js";
import { HeaderWrapper } from "../../components/PricesModals/styles";
import { getDecimals } from "../../helpers/getNumberFormats";
import { List, ListItem, Section } from "./styles";

export const PricesLog = () => {
  const history = useHistory();
  const { inserted, ignored } = useSelector(
    (state) => state.pricesSection.files
  );

  return (
    <Card>
      <CardHeader>
        <HeaderWrapper>
          <div>
            <h4>Registro de precios enviados</h4>
            <Muted>
              <h6>
                {inserted} insertados correctamente - {ignored.length} sin
                insertar
              </h6>
            </Muted>
          </div>
          <Button
            justIcon
            round
            color="info"
            onClick={() => history.goBack()}
          >
            <ArrowBackIcon />
          </Button>
        </HeaderWrapper>
      </CardHeader>
      <CardBody>
        <List>
          {ignored &&
            ignored.map((item) => (
              <ListItem key={item.id}>
                <Section>{item.company}</Section>
                <Section>{item.name}</Section>
                <Section>{getDecimals(item.price, 2)}</Section>
              </ListItem>
            ))}
        </List>
      </CardBody>
    </Card>
  );
};
